// conditional

import { Scene } from "three/src/scenes/Scene";
import * as THREE from "three";
import fragment from "./orbit-shader/fragment.glsl";
import vertex from "./orbit-shader/vertex.glsl";
import text from "../../img/orbits.png";
import gsap from "gsap";

import gsap from "gsap";
function lerp(a, b, n) {
  return (1 - n) * a + n * b;
}
function r(a, b) {
  return lerp(a, b, Math.random());
}

export default class Orbit extends Scene {
  constructor(parent) {
    super();
    this.globalcanvas = parent;
    this.time = 0;
    this.speed = 1.5;
    this.progress = 0;
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.needsRender = false;
    this.frustumSize = 3;
    this.aspect = this.width / this.height;
    this.camera = new THREE.OrthographicCamera(
      (this.frustumSize * this.aspect) / -2,
      (this.frustumSize * this.aspect) / 2,
      this.frustumSize / 2,
      this.frustumSize / -2,
      -100,
      100
    );
    this.camera.position.set(0, 0, 2);
    this.addImages();

    this.addObjects();
    // this.addTest();
    this.events();
    this.resize(this.width, this.height);
    
  }

  events() {
    let distance = 100;
    // this.event.on("move", ({ uv }) => {
    //   this.mouse.x = -(uv[0] - 0.5) * 0.2;
    //   this.mouse.y = -(uv[1] - 0.5) * 0.2;
    // });

    if(!window.locoScroll) return;
    window.locoScroll.on("scroll", (args) => {
      
      if (typeof args.currentElements["circles"] === "object") {
        
        if (!this.needsRender) {
          this.needsRender = true;
          // this.render();
        }
        this.progress = args.currentElements["circles"].progress;
        // this.update()
      } else {
        this.needsRender = false;
      }
    });
  }

  addImages() {
    if(!document.querySelector(".circles__images")) return;
    let images = document.querySelector(".circles__images");
    images = [...images.querySelectorAll("img")];
    let triggers = [...document.querySelectorAll(".js-circleslink")];
    this.meshes = [];

    let imagesPromises = images.map((image) => {
      return new Promise((resolve, reject) => {
        const loader = new THREE.TextureLoader();
        loader.load(image.src, (texture) => {
          resolve({ image, texture });
        });
      });
    });


    Promise.all(imagesPromises).then((images) => {
      images.forEach((o, i) => {
        let img = o.image;
        let texture = o.texture;
          console.log(texture);
          let theta = img.getAttribute("data-theta") * Math.PI;
          let which = img.getAttribute("data-ellipse");
          let material = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,
            opacity: 0.3,
          });
          let aspect = texture.source.data.width / texture.source.data.height;
          let geometry = new THREE.PlaneGeometry(0.4*aspect, 0.4);
          console.log(aspect,'aspect')
          if(aspect<1){
            
            geometry = new THREE.PlaneGeometry(.3, 0.3/aspect);
          }
          let mesh = new THREE.Mesh(geometry, material);
          let group = new THREE.Group();
          mesh.position.x = (i - 2.5) * 1.2;
          mesh.position.y = 0.5;
          mesh.position.z = 0.5;
          this.meshes.push({
            group,
            mesh,
            theta,
            ellipse: which,
          });
          group.add(mesh);
          this.add(group);
          let dur = 0.6;
          triggers[i].addEventListener("mouseenter", () => {
            gsap.to(mesh.material, { opacity: 1, duration: dur });
            gsap.to(mesh.scale, {
              x: 1.4,
              y: 1.4,
              duration: dur,
              ease: "power3.out",
            });
            gsap.to(this, { speed: 0, duration: dur });
          });
          triggers[i].addEventListener("mouseleave", () => {
            gsap.to(mesh.material, { opacity: 0.3, duration: dur });
            gsap.to(mesh.scale, {
              x: 1,
              y: 1,
              duration: dur,
              ease: "power3.inOut",
            });
            gsap.to(this, { speed: 1, duration: dur });
          });
      });

      if(!window.isMobile)this.globalcanvas.renderer.render(this, this.camera);

    })
    
    
  }

  addObjects() {
    let that = this;
    let tt = new THREE.TextureLoader().load(text);
    tt.minFilter = tt.magFilter = THREE.LinearFilter;
    let fix = Math.round(3*Math.max(0, (this.width/this.height -1) ))
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable",
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { value: 0 },
        copies: { value: 8+fix-2 },
        dir: { value: 1 },
        opacity: { value: 1 },
        resolution: { value: new THREE.Vector4() },
        texture1: { value: tt },
      },
      // wireframe: true,
      transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment,
    });

    let tempPlane = this.generateGeometry(this.aspect, 0.019);
    let tempPlane1 = this.generateGeometry(this.aspect * 1.2, 0.019);

    this.finalMesh = new THREE.Mesh(tempPlane, this.material);
    this.m1 = this.material.clone();
    this.m1.uniforms.texture1.value = tt;
    this.m1.uniforms.opacity.value = 0.7;
    this.m1.uniforms.dir.value = -1;
    this.m1.uniforms.copies.value = 9+fix-2;
    this.m1.uniforms.texture1.value.needUpdate = true;
    this.finalMesh1 = new THREE.Mesh(tempPlane1, this.m1);
    this.finalMesh1.rotation.z = -0.3;
    this.finalMesh1.position.z = -0.3;
    // finalMesh1.scale.set(0.9,0.9,0.9)
    // finalMesh1.alpha = 0.3

    this.add(this.finalMesh);
    this.add(this.finalMesh1);
  }

  generateGeometry(aspect, width) {
    let num = 100;
    let curvePoints = [];
    for (let i = 0; i < num; i++) {
      let theta = (i / num) * Math.PI * 2;
      curvePoints.push(
        new THREE.Vector3().set(aspect * Math.sin(theta), Math.cos(theta), 0)
      );
    }

    const curve = new THREE.CatmullRomCurve3(curvePoints);
    // curve.tension = 0.7;
    curve.closed = true;
    // const points = curve.getPoints(50);
    // const geometry = new THREE.BufferGeometry().setFromPoints(points);
    // const material = new THREE.LineBasicMaterial({ color: 0xff0000 });
    // const curveObject = new THREE.Line(geometry, material);
    // this.scene.add(curveObject)

    let number = 1000;

    let frenetFrames = curve.computeFrenetFrames(number, true);
    let spacedPoints = curve.getSpacedPoints(number);
    let tempPlane = new THREE.PlaneGeometry(1, 1, number, 1);
    let dimensions = [-width, width]; // @todo calculate this

    let point = new THREE.Vector3();
    let binormalShift = new THREE.Vector3();

    let finalPoints = [];
    dimensions.forEach((d) => {
      for (let i = 0; i <= number; i++) {
        point = spacedPoints[i];
        binormalShift.add(frenetFrames.binormals[i]).multiplyScalar(d);
        finalPoints.push(new THREE.Vector3().copy(point).add(binormalShift));
      }
    });

    finalPoints[0].copy(finalPoints[number]);
    finalPoints[number + 1].copy(finalPoints[2 * number + 1]);

    tempPlane.setFromPoints(finalPoints);

    return tempPlane;
  }

  getPoint(theta) {
    return new THREE.Vector3().set(
      1.5 * Math.sin(theta),
      1 * Math.cos(theta),
      0
    );
  }
  getDir(theta) {
    let p1 = this.getPoint(theta);
    let p2 = this.getPoint(theta + 0.01);
    let dir = { x: p2.x - p1.x, y: p2.y - p1.y };
    let len = Math.sqrt(dir.x ** 2 + dir.y ** 2);
    let x = dir.x / len;
    let y = dir.y / len;
    return new THREE(), Vector3(y, x, 0).normalize();
  }

  addTest() {
    this.mesh = new THREE.Mesh(
      new THREE.IcosahedronGeometry(0.1, 3),
      new THREE.MeshNormalMaterial()
    );
    this.add(this.mesh);
  }

  resize(w, h) {
    this.camera.aspect = w / h;
    this.width = w;
    this.height = h;
    this.camera.aspect = this.width / this.height;
    this.aspect = this.camera.aspect;

    this.camera.left = (this.frustumSize * this.aspect) / -2;
    this.camera.right = (this.frustumSize * this.aspect) / 2;
    this.camera.top = this.frustumSize / 2;
    this.camera.bottom = this.frustumSize / -2;
    this.camera.updateProjectionMatrix();
    this.vh = this.frustumSize*0.9
  }

  update() {
    this.position.y = -this.vh + 2 * this.vh * this.progress;

    this.time += 0.05 * this.speed;
    this.finalMesh.position.y = this.progress - 0.5;
    this.finalMesh1.position.y = 1.5 * (this.progress - 0.5);
    if (this.meshes.length > 0) {
      this.meshes.forEach((m, i) => {
        let p;
        if (m.ellipse == 1) {
          p = this.getPoint(m.theta - this.time * 0.006);
          p.x *= 1.3;
        } else {
          p = this.getPoint(m.theta + this.time * 0.006);
        }

        p.y += (i / 4) * (this.progress - 0.5);

        m.mesh.position.copy(p);
      });
    }
    this.material.uniforms.time.value = this.time;
    this.m1.uniforms.time.value = this.time;


  }
}
